// DataCenterPage.js
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import StickyHeader from '../../components/StickyHeader';
import StickyFooter from '../../components/StickyFooter';
import '../../css/Home.css';

function DataCenterPage() {
  const [isSystemParamsOpen, setIsSystemParamsOpen] = useState(true);
  const [isDcParamsOpen, setIsDcParamsOpen] = useState(true);
  const [isAcParamsOpen, setIsAcParamsOpen] = useState(true);

  useEffect(() => {
    // 初始化AOS动画库
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  const toggleSystemParams = () => {
    setIsSystemParamsOpen(!isSystemParamsOpen);
  };

  const toggleDcParams = () => {
    setIsDcParamsOpen(!isDcParamsOpen);
  };

  const toggleAcParams = () => {
    setIsAcParamsOpen(!isAcParamsOpen);
  };

  return (
    <div className="home-container">
      <StickyHeader />

      {/* 主要内容区域 */}
      <div className="main-content">
        <div className='stitle'>
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover"
            }}
            src={`${process.env.PUBLIC_URL}/imgs/bgran.png`}
            alt=""
          />
          <div className='co-text'>
            更可靠
          </div>
          <div className='co-texts'>
            大型储能系统
          </div>
          <div className='co-texty'>
            更高效
          </div>
          <div className='co-textys'>
            工商业储能系统
          </div>
          <div className='co-textno'>
            全面安全防护
          </div>
          <div className='co-textnos'>
            高效可靠运行
          </div>
          <div className='co-textysno'>
            智能运维管理
          </div>
          <div style={{
            position: "absolute",
            bottom: "40px",
            left: "40px",
            color: "white",
            textShadow: "0 2px 10px rgba(0, 0, 0, 0.7)",
            maxWidth: "60%"
          }}>
            <h2 style={{
              fontSize: "3.5rem",
              fontWeight: "700",
              marginBottom: "15px",
              letterSpacing: "2px",
              lineHeight: "1.2",
              margin: "0",
              padding: "0"
            }}>
              
            </h2>
            <p style={{
              fontSize: "1.3rem",
              lineHeight: "1.6",
              opacity: "0.95",
              margin: "0",
              padding: "0"
            }}>

            </p>
          </div>
        </div>
        <div style={{ minHeight: '800px' }}>
          {/* 第一个盒子 - 方案介绍 */}
          <div className='top1 animated-section'>
            <Container>
              <div className='box'>
                <div className='top'>
                  <div className='noe1' data-aos="fade-down">
                    <span className='h1'>产 品 介 绍</span>
                    <p>
                      <img src={`${process.env.PUBLIC_URL}/imgs/Dot.png`} alt="" className="dot-animation" />
                    </p>
                  </div>
                  <div className='boxnol'>
                    <div className='ritu' data-aos="fade-left" data-aos-delay="200">
                        <img src={`${process.env.PUBLIC_URL}/imgs/guiti.png`} alt="" className="image-hovers" />
                    </div>
                    <div className='lefs' data-aos="fade-right">
                      <h3 className='h3s'>
                      Enersafe Block-263-L
                      </h3>
                      <div className='bgf'></div>
                      <span className='textnoes'>
                      此系列是专为小型工商业开发的储能液冷一体柜，采用模块化设计，将电池系统RACK、电池管理系统BMS、储能变流器PCS、能量管理系统EMS、温控系统、消防系统、配电系统等设备集成在储能一体柜内部，云平台进行远程监控与调度管理，可即插即用，安装方便快捷。广泛应用于工商业削峰填谷、虚拟电厂、备用电源及三相不平衡治理等多种场景。
                      </span>
                    </div>
                   
                  </div>
                </div>
              </div>
            </Container>
          </div>

          

          {/* 第三个盒子 - 产品优势 */}
          <div className='top2s advantage-section'>
            <Container>
              <div className='box'>
                <div className='top'>
                  <div className='noe1' data-aos="fade-down">
                    <span className='h2s'>产 品 优 势</span>
                    <p>
                      <img src={`${process.env.PUBLIC_URL}/imgs/Dot.png`} alt="" className="dot-animation" />
                    </p>
                  </div>
                  <div className='boxnos'>
                    <div className='boxtoflex'>
                        <div className='boxtotops'>
                          多重防护
                        </div>
                        <div className='boxtotobt'>机柜安装3重泄压装置和3级消防设备，具备热失控告警和PACK级消防功能，智能守护储能系统。</div>
                    </div>
                    <div className='boxtoflexa'>
                        <div className='boxtotops'>
                        液冷温控
                        </div>
                        <div className='boxtotobt'>机柜配备车规级冷机，通过BMS实时监测PACK温度，液冷剂通过液冷管道循环流动，智能对高温、低温PACK进行调控。</div>
                    </div>
                    <div className='boxtoflexb'>
                        <div className='boxtotops'>
                        占地少
                        </div>
                        <div className='boxtotobt'>采用大容量电芯，储能系统能量密度高，占地空间小。</div>
                    </div>
                    <div className='boxtoflexc'>
                        <div className='boxtotops'>
                        功能多样
                        </div>
                        <div className='boxtotobt'>支持远程与本地控制，并网、离网、随时随地接收状态与故障信息。</div>
                    </div>
                    <div className='boxtoflexd'>
                        <div className='boxtotops'>
                        智能运营
                        </div>
                        <div className='boxtotobt'>机柜运行数据实时上传云平台，通过云平台可远程实时下发控制策略，设置需量、过载、逆流值，根据现场负荷自动调整运行状态，云平台具备电量统计、故障预警、寿命预测等功能。</div>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </div>
          {/* 第二个盒子 - 系统框图 */}
          <div className='top1 system-section' style={{ backgroundColor: "#f8f9fa", height: isSystemParamsOpen ? '900px' : '300px', transition: 'height 0.3s ease' }}>
            <Container>
              <div className='box'>
                <div className='top'>
                  <div className='noe1' data-aos="fade-down">
                    <span className='h1'>相 关 参 数</span>
                    <p>
                      <img src={`${process.env.PUBLIC_URL}/imgs/Dot.png`} alt="" className="dot-animation" />
                    </p>
                  </div>
                  <div className='lefttext-dow'>
                    系统参数
                  </div>
                  <div className="toggle-arrow-system" onClick={toggleSystemParams}>
                    <svg 
                      width="20" 
                      height="20" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2"
                      className={isSystemParamsOpen ? 'arrow-up' : 'arrow-down'}
                    >
                      <path d="M6 9l6 6 6-6"/>
                    </svg>
                  </div>
                  {isSystemParamsOpen && (
                    <div className='boxno' data-aos="zoom-in" data-aos-delay="300">
                      <img className='imgply' src={`${process.env.PUBLIC_URL}/imgs/yell.png`} alt="" />
                      <div className='text-xo'>
                      <p className='toubtext'> 循环次数</p>
                      <p className='toubtexts'> ≥6000次</p>
                      </div>
                      <div className='text-xoz'>
                      <p className='toubtextz'> 最大系统效率</p>
                      <p className='toubtextsz'> ≥91%</p>
                      </div>
                      <div className='text-xoza'>
                      <p className='toubtextz'> 冷却方式</p>
                      <p className='toubtextsz'> 液冷</p>
                      </div>
                      <div className='text-xozb'>
                      <p className='toubtextz'> 充放电倍率</p>
                      <p className='toubtextsz'> ≤0.5P</p>
                      </div>
                      <div className='text-xozc'>
                      <p className='toubtextz'> 工作温度</p>
                      <p className='toubtextsz'>-30°C-55°C</p>
                      </div>
                      <div className='text-xozd'>
                      <p className='toubtextz'> 放电深度</p>
                      <p className='toubtextsz'>100%DOD</p>
                      </div>
                      <div className='text-xoze'>
                      <p className='toubtextz'> 相对湿度</p>
                      <p className='toubtextsz'>≤95%,无凝露</p>
                      </div>
                      <div className='text-xozf'>
                      <p className='toubtextz'> 噪音</p>
                      <p className='toubtextsz'>＜75dB(距机柜1m处)</p>
                      </div>
                      <div className='text-xoy'>
                      <p className='toubtexty'> 海拔</p>
                      <p className='toubtextsy'> ≤2000m（＞2000m降频使用）</p>
                      </div>
                      <div className='text-xoya'>
                      <p className='toubtexty'> 充放电切换时间</p>
                      <p className='toubtextsy'> ≤100ms</p>
                      </div>
                      <div className='text-xoyb'>
                      <p className='toubtexty'> 系统尺寸（宽*高*深）</p>
                      <p className='toubtextsy'> 1200mm*2250mm*1400mm</p>
                      </div>
                      <div className='text-xoyc'>
                      <p className='toubtexty'> 消防系统</p>
                      <p className='toubtextsy'> 气体消防+可燃气体检测及排风+水消防</p>
                      </div>
                      <div className='text-xoyd'>
                      <p className='toubtexty'> 防盐雾等级</p>
                      <p className='toubtextsy'> 标配 C4</p>
                      </div>
                      <div className='text-xoye'>
                      <p className='toubtexty'> 防护等级</p>
                      <p className='toubtextsy'> IP55</p>
                      </div>
                      <div className='text-xoyf'>
                      <p className='toubtexty'> 重量</p>
                      <p className='toubtextsy'> 约2.6吨</p>
                      </div>
                      <div className='text-xob'>
                      <p className='toubtext'> 认证</p>
                      <p className='toubtexts'>GB/T 36276-2023, GB/T 34120-2023, GB/T 34131-2023等</p>
                      </div>
                      
                    </div>
                  )}
                </div>
              </div>
            </Container>
          </div>

          {/* 第四个盒子 - 直流侧参数 */}
          <div className='top8 lifecycle-section' style={{ backgroundColor: '#f8f9fa', height: isDcParamsOpen ? '650px' : '150px', transition: 'height 0.3s ease' }}>
            <Container>
              <div className='box'>
                <div className='topwai'>
                  <div className='lefttextcan'>
                    直流侧参数
                  </div>
                  <div className="toggle-arrow-dc" onClick={toggleDcParams}>
                    <svg 
                      width="20" 
                      height="20" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2"
                      className={isDcParamsOpen ? 'arrow-up' : 'arrow-down'}
                    >
                      <path d="M6 9l6 6 6-6"/>
                    </svg>
                  </div>
                  {isDcParamsOpen && (
                    <div className='dianxin'>
                      <div className='boxpin'>
                        <p className='textp'>电芯类型</p>
                        <p className='textp2'>LFP3.2V/314Ah</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>电池额定电量</p>
                        <p className='textp2'>261kWh</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>电芯成组方式</p>
                        <p className='textp2'>1*1P260S</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>电池电压范围</p>
                        <p className='textp2'>728-949V</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>单体电压上限</p>
                        <p className='textp2'>3.65V</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>单体电压下限</p>
                        <p className='textp2'>2.8V</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>电池额定电压</p>
                        <p className='textp2'>832V</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>温度检测数目</p>
                        <p className='textp2'>140</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>直流保护</p>
                        <p className='textp2'>接触器+FUSE</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Container>
          </div>

          {/* 第五个盒子 - 交流侧参数 */}
          <div className='top8 lifecycle-section' style={{ backgroundColor: '#f8f9fa', height: isAcParamsOpen ? '650px' : '150px', transition: 'height 0.3s ease' }}>
            <Container>
              <div className='box'>
                <div className='topwai'>
                  <div className='lefttextcan'>
                    交流侧参数
                  </div>
                  <div className="toggle-arrow-ac" onClick={toggleAcParams}>
                    <svg 
                      width="20" 
                      height="20" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2"
                      className={isAcParamsOpen ? 'arrow-up' : 'arrow-down'}
                    >
                      <path d="M6 9l6 6 6-6"/>
                    </svg>
                  </div>
                  {isAcParamsOpen && (
                    <div className='dianxin'>
                      <div className='boxpin'>
                        <p className='textp'>交流额定功率</p>
                        <p className='textp2'>100kW</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>额定输出电流</p>
                        <p className='textp2'>145A</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>交流接入方式</p>
                        <p className='textp2'>三相四线</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>电网电压范围</p>
                        <p className='textp2'>400V(-20%～+15%)</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>过载能力</p>
                        <p className='textp2'>1.1倍长期，1.2倍1min</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>功率因数</p>
                        <p className='textp2'>-0.99～+0.99</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>额定电网频率</p>
                        <p className='textp2'>50Hz/60Hz±2.5Hz</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>电流总谐波畸变率</p>
                        <p className='textp2'>≤3%( 满载)</p>
                      </div>
                      <div className='boxpin'>
                        <p className='textp'>直流分量</p>
                        <p className='textp2'>≤0.5%</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Container>
          </div>

        </div>

      </div>

      <StickyFooter />
    </div>
  );
}

export default DataCenterPage;